import React from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Cookies from "js-cookie";
import DataTableExtensions from "react-data-table-component-extensions";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import ExportProductsFromDropShippingHook from "../../hook/product/ExportProductsFromDropShippingHook";
import LoadingSpinner from "../Utilities/LoadingSpinner";
import SearchByTypingSelect from "../Utilities/SearchByTypingSelect";
import Pagination from "../Utilities/Pagination";

const AdminProductsFromDropShipping = () => {
  const { t } = useTranslation();

  const [
    products,
    handleRowSelected,
    settingsRes,
    showAddProductModal,
    setShowAddProductModal,
    categoryId,
    onSelectCategory,
    category,
    selectedsubId,
    subCategory,
    onSelectSubCategory,
    brandId,
    onSelectBrand,
    brand,
    vedorId,
    onChangeVendor,
    getAllUser,
    showModal,
    saveProducts,
    isloading,
    isAdding,
    selectedRows,
    showTable,
    setShowTable,
    startDate,
    setStartData,
    endDate, 
    setEndDate,
    status,
    setStatus,
    numberOfPages,
    setNumberOfPages,
    getPage,
    handleClick,
    isLoading,
    clearSelectedRows, setClearSelectedRows,
    hideModal,
    nextPageLoading
  ] = ExportProductsFromDropShippingHook();



  console.log("selectedRows",selectedRows);

  //   if(1) return<>
  // <label htmlFor="dropShippingMethods" className="d-block mt-2">{t('dropShippingIds')}</label>
  // <input 
  // onChange={(e)=>setIds(e.target.value)}
  // className="input-form d-block mt-2 px-3 w-75" 
  // placeholder={t('dropShippingIds')} />
  // <button
  // onClick={handleClick}
  // style={{ backgroundColor: settingsRes?.data?.primaryColor }} 
  //  className="btn-save d-inline mt-2"
  //  >{t("save")}</button>
  //   </> 
  const customStyles = {
  headCells: {
    style: {
     display:'flex',
     justifyContent:'center'
    },
  },
  // rows: {
  //   style: {
  //     backgroundColor: '#fff',
  //     fontSize: '14px',
  //     color: '#444',
  //     minHeight: '48px', // optional row height
  //   },
  // },
  // cells: {
  //   style: {
  //     padding: '8px 16px',
  //   },
  // },
};

  if (isloading) return <LoadingSpinner />;

  let columns = [
    {
      name: t("Title name"),
      selector: "title",
      sortable: true
    },

    {
      name: t("image"),
      cell: (row) => (
        <>
        {/* {
          row?.description
        } */}
          {
            <img
              alt="sliderImage"
              src={row?.images[0]}
              width="200px"
              height="100px"
              style={{ padding: "3px", objectFit: "contain" }}
            />}
        </>

      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    
    {
      name: t("price"),
      // selector: "price",
      cell: (row) => (
        <div className="d-flex justify-content-center w-100">
          {row?.price/100}
        </div>
      ),
      sortable: true
    },


    {
      name: t("the status"),
       cell: (row) => (
        <div className="d-flex justify-content-center w-100">
          {row?.status}
        </div>
      ),
      sortable: true
    },
  ];


  const tableData = {
    columns,
    data: products,
  };

  console.log('products?.length',products?.length);

  return (
    <div>
      <Helmet>
        <title>{`${t("addProductsDropShippings")}  -  ${Cookies.get("i18next") === "ar" ? settingsRes.data?.titleAr : settingsRes.data?.titleEn}`} </title>
      </Helmet>

      <div>
        <label htmlFor="starting date" className="d-block mt-2">{t('starting date')}</label>
        <input
          value={startDate}
          type="date"
          onChange={(e) =>setStartData(e.target.value)}
          className="input-form d-block mt-2 px-3 w-75"
           />

        <label htmlFor="ending date" className="d-block mt-2">{t('ending date')}</label>
        <input
          value={endDate}
          type="date"
          onChange={(e) =>setEndDate(e.target.value)}
          className="input-form d-block mt-2 px-3 w-75"
           />

        <label htmlFor="the status" className="d-block mt-2">{t('the status')}</label>
        <select className="input-form d-block mt-2 px-3 w-75" value={status} onChange={(e) =>setStatus(e.target.value)} >
          <option value={'NORMAL'}>NORMAL</option>
          <option value={'CANCEL'}>CANCEL</option>
          <option value={'INACTIVE'}>INACTIVE</option>
        </select>
        <button
          onClick={handleClick}
          style={{ backgroundColor: settingsRes?.data?.primaryColor }}
          disabled={isLoading}
          className="btn-save d-inline mt-2"
        >
          {isLoading ? <Spinner /> : t("import")}
          </button>
      </div>

      <div className="d-flex justify-content-center">
        {isLoading && <Spinner />}
      </div>
      

      <Modal show={showAddProductModal} onHide={() => hideModal()}>
        <Modal.Header>
          <Modal.Title>
            <div className="font">{t("add product")} </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="categoriesProduct" className="d-block mt-4">
            {t("main classification")}
          </label>
          <SearchByTypingSelect
            value={categoryId}
            onChange={onSelectCategory}
            getOptionLabel={(el) => Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
            getOptionValue={(e) => e._id}
            options={category}
            placeholder={t("main classification")}
          />

          <label htmlFor="subCategoriesProduct" className="d-block mt-2 ">
            {t("Subcategory")}
          </label>
          <SearchByTypingSelect
            value={selectedsubId}
            onChange={onSelectSubCategory}
            getOptionLabel={(el) => Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
            getOptionValue={(e) => e._id}
            options={subCategory}
            placeholder={t("Subcategory")}
          />

          <label htmlFor="brand" className="d-block mt-2 ">
            {t("Brand")}
          </label>
          <SearchByTypingSelect
            value={brandId}
            onChange={onSelectBrand}
            getOptionLabel={(el) => Cookies.get("i18next") == "ar" ? el.nameAr : el.nameEn}
            getOptionValue={(e) => e._id}
            options={brand.data}
            placeholder={t("Brand")}
          />

          <label htmlFor="vendor" className="d-block mt-2 ">
            {t("select vendor name")}
          </label>
          <SearchByTypingSelect
            value={vedorId}
            onChange={onChangeVendor}
            getOptionLabel={(el) => `${el?.firstname} ${el?.lastname}`}
            getOptionValue={(e) => e._id}
            options={getAllUser}
            placeholder={t("vendor name")}
          />
          <Row>
            <Col sm="12" className="d-flex justify-content-start mt-2">
              <button
                disabled={isLoading}
                onClick={saveProducts}
                className="btn-save d-inline mt-3"
                style={{
                  backgroundColor: settingsRes?.data?.primaryColor,
                  opacity: isAdding ? "0.5" : "1"
                }}
              >
                { isLoading ? <Spinner /> : t("save")}
              </button>
            </Col>
          </Row>




        </Modal.Body>

      </Modal>
      {
        nextPageLoading ?
        <LoadingSpinner />   
        :  
        <DataTableExtensions {...tableData} filter={false}>
          <DataTable
            noHeader
            defaultSortAsc={false}
            
            highlightOnHover
            selectableRows
            // selectedRows={selectedRows}
            onSelectedRowsChange={handleRowSelected}
            customStyles={customStyles}
          />
        </DataTableExtensions>
      }


      <Row>
        {
          products?.length > 0  && <Col className="d-flex justify-content-start" >
            <button
              onClick={showModal}
              className="btn-save  mt-2"
              style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            >
              {t("import")}
            </button>
          </Col>
        }

      </Row>

       {
        products?.length > 0  
        && 
        <Pagination pageCount={numberOfPages} onPress={getPage} /> 
       } 
      <ToastContainer />
    </div>
  );
};

export default AdminProductsFromDropShipping;
